import { endpoints } from '@/api/endpoints';
import { useApi } from '@/api/useApi';

/** Sellers and warehouses for the list filter bar. A failed or forbidden lookup simply hides that selector (the list still works). */
export function useFilterOptions(): {
  readonly sellers: readonly { value: string; label: string }[];
  readonly warehouses: readonly { value: string; label: string }[];
} {
  const sellers = useApi(() => endpoints.sellers({ limit: 200 }), []);
  const warehouses = useApi(() => endpoints.warehousesList(), []);
  return {
    sellers: sellers.status === 'success' ? (sellers.data.rows ?? []).map((s) => ({ value: s.id, label: s.name })) : [],
    warehouses: warehouses.status === 'success' ? (warehouses.data.warehouses ?? []).map((w) => ({ value: w.id, label: w.name })) : [],
  };
}
